import { state } from './state.js';

export function isLegacyHighresDraftToggleOn() {
    const toggle = document.getElementById('legacyHighresDraftToggle');
    return Boolean(toggle && toggle.checked);
}

export function getDraftLongEdgePx() {
    const plan = state.plan || {};
    const raw = Number(plan.draft_long_edge_px || 1600);
    if (!Number.isFinite(raw) || raw <= 0) return 1600;
    return Math.round(raw);
}

export function resolveDraftScale(origW, origH) {
    const sourceEdge = Math.max(Number(origW || 0), Number(origH || 0));
    if (!sourceEdge) return null;
    if (isLegacyHighresDraftToggleOn()) {
        const scaleInput = document.getElementById('scaleInput');
        const legacyScale = Number(scaleInput ? scaleInput.value : NaN);
        if (Number.isFinite(legacyScale) && legacyScale > 0) return legacyScale;
    }
    return (Number(getDraftLongEdgePx()) + 0.999) / sourceEdge;
}
